import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, ProgressCircle, Text, TextField, Well, } from '@adobe/react-spectrum';
import { getPublishJob } from 'app/stores/publish/selectors';
import { getPlatformTag } from 'app/views/components/dialogs/publish/platform';
export const PublishingWell = (props) => {
    const { platform } = props;
    const publishJob = useSelector((state) => getPublishJob(state, platform));
    switch (publishJob === null || publishJob === void 0 ? void 0 : publishJob.state) {
        case 'publishing':
            return (React.createElement(Well, { "data-test-id": `publishing-${getPlatformTag(platform)}` },
                React.createElement(Flex, { width: "100%", height: "100%", justifyContent: "center", alignItems: "center" },
                    React.createElement(ProgressCircle, { "aria-label": "Loading\u2026", isIndeterminate: true }))));
        case 'published':
            return (React.createElement(Well, { "data-test-id": `published-${getPlatformTag(platform)}` },
                React.createElement(Flex, { direction: "column" },
                    React.createElement(Text, null, "Image url"),
                    React.createElement(TextField, { width: "100%", flex: "1", isReadOnly: true, label: "Image url", value: publishJob.url }))));
        case 'error':
            return (React.createElement(Well, { "data-test-id": `error-${getPlatformTag(platform)}` },
                React.createElement(Flex, { direction: "column" },
                    React.createElement(Text, null, "Publishing failed with error"),
                    React.createElement(TextField, { width: "100%", flex: "1", isReadOnly: true, label: "Error", value: publishJob.message }))));
        default:
            break;
    }
    return props.children;
};
